var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverflowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.166 16.0007C15.166 15.5404 15.5391 15.1673 15.9993 15.1673C16.4596 15.1673 16.8327 15.5404 16.8327 16.0007C16.8327 16.4609 16.4596 16.834 15.9993 16.834C15.5391 16.834 15.166 16.4609 15.166 16.0007Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9993 16.0007C20.9993 15.5404 21.3724 15.1673 21.8327 15.1673C22.2929 15.1673 22.666 15.5404 22.666 16.0007C22.666 16.4609 22.2929 16.834 21.8327 16.834C21.3724 16.834 20.9993 16.4609 20.9993 16.0007Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33268 16.0007C9.33268 15.5404 9.70578 15.1673 10.166 15.1673C10.6263 15.1673 10.9993 15.5404 10.9993 16.0007C10.9993 16.4609 10.6263 16.834 10.166 16.834C9.70578 16.834 9.33268 16.4609 9.33268 16.0007Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.166 16.0007C15.166 15.5404 15.5391 15.1673 15.9993 15.1673C16.4596 15.1673 16.8327 15.5404 16.8327 16.0007C16.8327 16.4609 16.4596 16.834 15.9993 16.834C15.5391 16.834 15.166 16.4609 15.166 16.0007Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9993 16.0007C20.9993 15.5404 21.3724 15.1673 21.8327 15.1673C22.2929 15.1673 22.666 15.5404 22.666 16.0007C22.666 16.4609 22.2929 16.834 21.8327 16.834C21.3724 16.834 20.9993 16.4609 20.9993 16.0007Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33268 16.0007C9.33268 15.5404 9.70578 15.1673 10.166 15.1673C10.6263 15.1673 10.9993 15.5404 10.9993 16.0007C10.9993 16.4609 10.6263 16.834 10.166 16.834C9.70578 16.834 9.33268 16.4609 9.33268 16.0007Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverflowIcon);
export default __webpack_public_path__ + "static/media/overflow-icon.38f09a334f0809052130337fb19bfa86.svg";
export { ForwardRef as ReactComponent };